import {
  Component,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import {
  currencyValues,
  lineQuantityMisurements,
  countryReference,
  exportReasonValues,
  inCoTerms,
  uoms,
  paperTradeList,
  exportInvoice,
  imageDocTemplates,
  configurationPageList,
  onBoarding,
  bbxTypes,
  labelPrintTypes,
  validForSISizeMessage,
  placesofIncotermList,
} from 'src/app/utils/constants/strings';
import {
  basicSnackBarConfig,
  getPlaceofIncotermValue,
  patchValueToFormsInCustomerOnBoarding,
} from 'src/app/utils/default-configs/configuration';
import {
  configurationIdMap,
  configurationIdMapForShipmentDetailsUpdate,
  configurationIdMapForProductName,
} from 'src/app/utils/constants/constant';
import { debounceTime, distinctUntilChanged, pairwise } from 'rxjs/operators';
import { convertCustomerOnBoarding } from './convertor/customer-onboarding-convertor';
import { BehaviourService } from '../../../shared/services/behaviour.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import { AlertComponent } from 'src/app/core/components/alert/alert.component';
import { LabelViewComponent } from 'src/app/shared/label-view/label-view.component';
import { environment } from 'src/environments/environment';
import { createConfigArray } from 'src/app/utils/default-configs/configuration';

import moment from 'moment';
import { CryptoService } from 'src/app/utils/default-configs/crypto.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-customer-onboarding',
  templateUrl: './customer-onboarding.component.html',
  styleUrls: ['./customer-onboarding.component.scss'],
})
export class CustomerOnboardingComponent implements OnInit, OnDestroy {
  configurationList = configurationPageList;
  configOnBoarding = onBoarding;
  defaultUOMGroup: FormGroup;
  defaultCurrencyGroup: FormGroup;
  defaultCountryGroup: FormGroup;
  defaultWeightGroup: FormGroup;
  defaultDecimalGroup: FormGroup;
  motherAccountGroup: FormGroup;
  babyAccountGroup: FormGroup;
  MotherIncotermGroup: FormGroup;
  defaultIncotermGroup: FormGroup;
  ExportDeclarationGroup: FormGroup;
  ImagePropertiesGroup: FormGroup;
  ReportParamsGroup: FormGroup;
  PaperLessTradeGroup: FormGroup;
  exportInvoiceGroup: FormGroup;
  customerCredentialGroup: FormGroup;
  bbxConfigGroup: FormGroup;
  pickupsConfigGroup: FormGroup;
  labelPrintConfigGroup: FormGroup;
  babyDefaultOptionsGroup: FormGroup;
  defaultShipmentContent: FormGroup;
  reportConfigGroup: FormGroup;
  individualShipAccountGroup: FormGroup;
  individualShipmentExportDeclarationGroup: FormGroup;
  list = countryReference;
  manufactureCountryList = countryReference;
  searchTerm: string = '';
  incoterms = inCoTerms;

  uoms = uoms;
  paperTradeList = paperTradeList;
  lineQuantityMisurements = lineQuantityMisurements;
  exportReasonValues = exportReasonValues;
  exportInvoice = exportInvoice;
  bbxTypes = bbxTypes;
  labelPrintTypes = labelPrintTypes;
  imageDocTemplates = imageDocTemplates;
  motherShipperBtn: boolean;
  defaultUnitBtn: boolean;
  defalutCurrency = currencyValues;
  apiList = ['MyDHL API', 'Postal Location API'];
  onChangeLabelTypeMapping = {
    ECOM26_84_A4_001: 'ARCH_8X4_A4_002',
    ECOM26_84_001: 'ARCH_8X4',
    ECOM26_A6_002: 'ARCH_6X4',
  };
  onChangeLabelTypeMappingLbbx = {
    ECOM26_84_LBBX_001: 'ARCH_8X4',
    ECOM26_64_LBBX_001: 'ARCH_6X4',
  };
  trueFalseOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  defalutDecValues = [3, 5];
  selectedConfiguration: number = 0;
  configurationIdMap = configurationIdMap;
  configurationPageList = configurationPageList;
  cityList = [];
  isPostalCodeReq: boolean;
  isPostalCodeValid: boolean = true;
  isCityValid: boolean = true;
  filteredCountry = countryReference;
  bbxUserRole: any;
  serviceSubscription$ = new Subscription();
  credSubscription$ = new Subscription();
  mappSubscription$ = new Subscription();
  customerOnBoardingVerification: string = '';
  dhlPswdReqd: boolean = false;
  dhlKeyReqd: boolean = false;
  fieldTextType: boolean;
  looseBbx: boolean;
  signatureImage: string | ArrayBuffer = '';
  signatureImageData = null;
  placesofIncoterm = placesofIncotermList;
  DGContentIDValues: any = [];
  specialProvision = ['HU5', 'E01'];
  isSpecialProvisionSelected: boolean = false;
  currentSelectedContent = '';
  signatureImageIndShip: string | ArrayBuffer = '';
  signatureImageDataIndShip = null;
  allProductNameValues: [];
  individualProductCodes: [];
  selectedProductNames: any = [];

  closeError: boolean;
  readyError: boolean;
  selectedTime;
  selectedDate;
  currentDate;
  @ViewChild('mySelect') mySelect: FormControl;
  emailArray: any;
  labelTypes: any;
  decryptedPassword: any;

  constructor(
    private configService: ConfigService,
    private fb: FormBuilder,
    private errorDialogService: ErrorDialogService,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private behaviourService: BehaviourService,
    private dialogRef: MatDialog,
    private snackBarService: SnackBarService,
    private cryptoService: CryptoService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.renderFormInitialise();
    this.getDefaultConfiguration();
    this.bbxUserRole = sessionStorage.getItem('bbx-role');

    this.serviceSubscription$.add(
      this.behaviourService.currentArray.subscribe(response => {
        if (response.length > 0) {
          this.customerOnBoardingVerification = response[1];
          this.validateConfig(response[0]);
        }
      })
    );
    this.mappSubscription$.add(
      this.behaviourService.currentMessage.subscribe(data => {
        if (data == 'mother_baby_destcountry_mapping') {
          this.dialogRef.closeAll();
        }
      })
    );
    this.customerCredentialDisplay();

    this.babyDefaultOptionsGroup
      .get('DGContentID')
      .valueChanges.pipe(pairwise())
      .subscribe(([prev, next]) => {
        const difference = next.filter(x => !prev.includes(x));
        this.currentSelectedContent = difference[0];
      });
    this.readyTime();
    this.closeTime();

    //only global_admin and country_it_admin should have access
    this.filterSaveAddressAccess();
  }

  readyTime() {
    this.pickupsConfigGroup
      .get('readyTime')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (newValue) {
          this.selectedTime = newValue;
          if (this.pickupsConfigGroup.get('closingTime').value) {
            const startTime = moment(this.pickupsConfigGroup.get('closingTime').value, 'HH:mm');
            const endTime = moment(this.selectedTime, 'HH:mm');
            const duration = moment.duration(startTime.diff(endTime));
            const hours = Number(duration.asHours());
            if (hours < 2) {
              this.closeError = true;
            } else {
              this.closeError = false;
            }
          }
        }
      });
  }

  closeTime() {
    this.pickupsConfigGroup
      .get('closingTime')
      .valueChanges.pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (newValue) {
          const startTime = moment(newValue, 'HH:mm');
          const endTime = moment(this.selectedTime, 'HH:mm');
          const duration = moment.duration(startTime.diff(endTime));
          const hours = Number(duration.asHours());
          if (hours < 2) {
            this.closeError = true;
          } else {
            this.closeError = false;
          }
        }
      });
  }

  ngOnDestroy() {
    this.serviceSubscription$.unsubscribe();
    this.behaviourService.sendEvent(null);
    this.credSubscription$.unsubscribe();
    this.mappSubscription$.unsubscribe();
  }

  validateConfig(response) {
    if (response.length > 0) {
      this.configurationList = this.configurationPageList = convertCustomerOnBoarding(response);
      this.selectedConfiguration = this.configurationList[0].group_id;
      if (
        !this.configurationList.some(item => item.config_id === 'mother_baby_destcountry_mapping')
      ) {
        this.viewContainerRef.clear();
      }
      // this.configurationList.some(item => item.config_id == 'mother_baby_destcountry_mapping') ==
      // false
      //   ? this.viewContainerRef.clear()
      //   : '';
    }
  }

  lazyDestinationModule() {
    import('../../destination-mapping/destination-mapping.module').then(
      ({ DestinationMappingModule }) =>
        this.viewContainerRef.createComponent(
          this.componentFactoryResolver.resolveComponentFactory(
            DestinationMappingModule.getDestinationModuleComponents()
          )
        )
    );
  }

  lazyEmailConfigurationComponent() {
    import('../email-mapping-list/email-mapping.component').then(({ EmailMappingComponent }) =>
      this.viewContainerRef.createComponent(
        this.componentFactoryResolver.resolveComponentFactory(EmailMappingComponent)
      )
    );
  }

  lazyMotherShipperConfigurationComponent() {
    import('../mother-shipper/mother-shipper-list/mother-shipper-list.component').then(
      ({ MotherShipperListComponent }) =>
        this.viewContainerRef.createComponent(
          this.componentFactoryResolver.resolveComponentFactory(MotherShipperListComponent)
        )
    );
  }

  setMotherProductCode() {
    const babyPorductCode = this.babyDefaultOptionsGroup.get('productCode').value;
    const motherProductCodeCtrl = this.babyDefaultOptionsGroup.get('motherProductCode');
    if (babyPorductCode === 'B') {
      motherProductCodeCtrl.setValue('P');
    } else if (babyPorductCode === 'A') {
      motherProductCodeCtrl.setValue('H');
    } else {
      motherProductCodeCtrl.setValue('P');
    }
  }

  filterBySearch(searchTerm) {
    if (searchTerm && searchTerm.trim() !== '') {
      this.configurationList = this.configurationPageList.filter(
        item => item?.title.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    } else {
      this.configurationList = this.configurationPageList;
    }
  }

  selectedConfig(item) {
    this.viewContainerRef.clear();
    this.selectedConfiguration = item?.group_id;

    if (item?.group_id === this.configOnBoarding.MAWB_COUNTRY_CONFIGURATION) {
      this.lazyDestinationModule();
    }

    if (item?.group_id === this.configOnBoarding.EMAIL_CONFIGURATION) {
      this.lazyEmailConfigurationComponent();
    }

    if (item?.group_id === this.configOnBoarding.MOTHER_SHIPPER_DETAILS) {
      this.lazyMotherShipperConfigurationComponent();
    }

    if (item?.group_id === this.configOnBoarding.BABY_DEFAULT_OPTIONS) {
      this.getDGContentIDs();
      this.getProductNameData();
    }
  }
  // selectedConfig(item) {
  //   this.viewContainerRef.clear();
  //   this.selectedConfiguration = item?.group_id;
  //   item?.group_id === this.configOnBoarding.MAWB_COUNTRY_CONFIGURATION &&
  //     this.lazyDestinationModule();
  //   item?.group_id === this.configOnBoarding.EMAIL_CONFIGURATION &&
  //     this.lazyEmailConfigurationComponent();
  //   item?.group_id === this.configOnBoarding.MOTHER_SHIPPER_DETAILS &&
  //     this.lazyMotherShipperConfigurationComponent();
  //   item?.group_id === this.configOnBoarding.BABY_DEFAULT_OPTIONS && this.getDGContentIDs();
  // }

  getDefaultConfiguration() {
    this.configService.getConfigs(createConfigArray(configurationIdMap)).then(response => {
      response.forEach(item => {
        if (item && item?.config_id) {
          item?.config_id === configurationIdMap.MOTHER_ACCOUNT_NUMBERS ||
          item.config_id === configurationIdMap.INDIVIDUAL_SHIP_ACCOUNT_NUMBERS ||
          item.config_id === configurationIdMap.BABY_ACCOUNT_NUMBERS
            ? this.patchForms(item?.config_id, item?.data)
            : this.patchForms(item?.config_id, item?.data[0]);

          if (item?.config_id === configurationIdMap.LOOSE_BBX) {
            if (item.data[0] === 'Yes') {
              this.looseBbx = true;
              this.labelTypes = this.imageDocTemplates.labelTypesLbbx;
            } else {
              this.looseBbx = false;
              this.labelTypes = this.imageDocTemplates.labelTypes;
            }
          }

          // item?.config_id === configurationIdMap.LOOSE_BBX
          //   ? (this.looseBbx = item.data[0] === 'Yes')
          //   : false;
          if (item?.config_id === configurationIdMap.BABY_DEFAULT_OPTIONS) {
            this.getDGContentValue({
              value: item.data[0].DGContentID,
              description: item.data[0].customDescription,
            });
          }
        }
      });
    });
  }

  patchForms(formName, formData) {
    const formConfigs = {
      default: () => ``,
      default_unitofmeasurement: () =>
        patchValueToFormsInCustomerOnBoarding(this.defaultUOMGroup, formName, formData),
      default_currency: () =>
        patchValueToFormsInCustomerOnBoarding(this.defaultCurrencyGroup, formName, formData),
      default_countryofmanufacture: () =>
        patchValueToFormsInCustomerOnBoarding(this.defaultCountryGroup, formName, formData),
      default_weight: () =>
        patchValueToFormsInCustomerOnBoarding(this.defaultWeightGroup, formName, formData),
      default_shipment_content: () =>
        patchValueToFormsInCustomerOnBoarding(this.defaultShipmentContent, formName, formData),
      mother_accountnumbers: () =>
        patchValueToFormsInCustomerOnBoarding(this.motherAccountGroup, formName, formData),
      baby_accountnumbers: () =>
        patchValueToFormsInCustomerOnBoarding(this.babyAccountGroup, formName, formData),
      individualShip_accountnumbers: () =>
        patchValueToFormsInCustomerOnBoarding(this.individualShipAccountGroup, formName, formData),
      mother_incoterm: () =>
        patchValueToFormsInCustomerOnBoarding(this.MotherIncotermGroup, formName, formData),
      default_incoterm: () =>
        patchValueToFormsInCustomerOnBoarding(this.defaultIncotermGroup, formName, formData),
      mother_exportdeclarationdetails: () => {
        this.signatureImage = formData.content.exportDeclaration.invoice.signatureImage;
        patchValueToFormsInCustomerOnBoarding(this.ExportDeclarationGroup, formName, formData);
      },
      individualShipment_exportdeclarationdetails: () => {
        this.signatureImageIndShip = formData.content.exportDeclaration.invoice.signatureImage;
        patchValueToFormsInCustomerOnBoarding(
          this.individualShipmentExportDeclarationGroup,
          formName,
          formData
        );
      },
      output_imageproperties: () =>
        patchValueToFormsInCustomerOnBoarding(this.ImagePropertiesGroup, formName, formData),
      prealert_reportparams: () =>
        patchValueToFormsInCustomerOnBoarding(this.ReportParamsGroup, formName, formData),
      default_invoice_export: () => {
        patchValueToFormsInCustomerOnBoarding(this.exportInvoiceGroup, formName, formData);
      },
      'paperless-trade': () =>
        patchValueToFormsInCustomerOnBoarding(this.PaperLessTradeGroup, formName, formData),
      customer_credential: async () => {
        this.decryptedPassword = await this.cryptoService.decryptPassword(
          formData?.mydhlApiPassword,
          environment.VAULT_GLS_API_KEY
        );
        patchValueToFormsInCustomerOnBoarding(
          this.customerCredentialGroup,
          formName,
          formData,
          this.decryptedPassword
        );
      },
      loose_bbx: () =>
        patchValueToFormsInCustomerOnBoarding(this.bbxConfigGroup, formName, formData),
      unitPriceDecimalPoints: () =>
        patchValueToFormsInCustomerOnBoarding(this.defaultDecimalGroup, formName, formData),
      label_print_config: () =>
        patchValueToFormsInCustomerOnBoarding(this.labelPrintConfigGroup, formName, formData),
      baby_default_options: () =>
        patchValueToFormsInCustomerOnBoarding(this.babyDefaultOptionsGroup, formName, formData),
      pickup_default_settings: () =>
        patchValueToFormsInCustomerOnBoarding(this.pickupsConfigGroup, formName, formData),
      report_configuration: () => {
        patchValueToFormsInCustomerOnBoarding(this.reportConfigGroup, formName, formData);
        this.emailArray = formData.EmailList;
      },
    };
    return (formConfigs[formName] || formConfigs.default)();
  }

  renderFormInitialise() {
    this.intialiseDefaultUOMGroup();

    this.intialiseDefaultCurrencyGroup();
    this.intialiseDefaultCountryGroup();
    this.intialisedefaultWeightGroup();
    this.initialisedefaultShipmentContent();
    this.intialisemotherAccountGroup();

    this.intialisebabyAccountGroup();
    this.intialiseIndividualShipAccountGroup();
    this.intialiseIndividualShipmentExportDeclarationGroup();
    this.intialisemotherIncotermGroup();
    this.intialiseDefaultIncotermGroup();
    this.intialiseExportDeclarationGroup();
    this.intialiseImagePropertiesGroup();
    this.intialiseReportParamsGroup();
    this.intialisePaperLessTradeGroup();
    this.intialiseExportInvoiceFormGroup();
    this.intialiseCustomerCredentialFormGroup();
    this.intialiseBbxConfigGroup();
    this.intialisePickupsConfigGroup();
    this.intialiseUnitPriceDecimalGroup();
    this.intialiseLabelPrintConfigGroup();
    this.initialiseBabyDefaultOptions();
    this.intialisereportConfigGroup();
  }

  intialiseExportInvoiceFormGroup() {
    this.exportInvoiceGroup = this.fb.group({
      exportInvoice: new FormControl('', Validators.compose([Validators.required])),
    });
  }
  intialisereportConfigGroup() {
    this.reportConfigGroup = this.fb.group({
      email: new FormControl('', Validators.email),
      EmailList: new FormControl('', Validators.required),
      senderEmail: new FormControl(environment.senderEmailReports),
      emailBodyContents: new FormControl('', Validators.required),
    });
  }

  intialisemotherAccountGroup() {
    this.motherAccountGroup = this.fb.group({
      payerAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9)])
      ),
      dutyAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.minLength(9), Validators.maxLength(9)])
      ),
      shipperAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9)])
      ),
    });
  }

  intialisebabyAccountGroup() {
    this.babyAccountGroup = this.fb.group({
      payerAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9)])
      ),
      dutyAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.minLength(9), Validators.maxLength(9)])
      ),
      shipperAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9)])
      ),
    });
  }

  intialiseDefaultUOMGroup() {
    this.defaultUOMGroup = this.fb.group({
      invoiceUnitOfMeasurement: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(60)])
      ),

      lineItemQuantityUnitofMeasurement: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
    });
  }

  intialiseDefaultCurrencyGroup() {
    this.defaultCurrencyGroup = this.fb.group({
      declaredValueCurrency: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(3)])
      ),
    });
  }

  intialiseDefaultCountryGroup() {
    this.defaultCountryGroup = this.fb.group({
      manufactureCountry: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(2)])
      ),
    });
  }

  intialisePaperLessTradeGroup() {
    this.PaperLessTradeGroup = this.fb.group({
      paperlessTrade: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  intialisedefaultWeightGroup() {
    this.defaultWeightGroup = this.fb.group({
      shipmentWeight: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(10),
          Validators.min(0.1),
          Validators.pattern('^-?[0-9]+(.[0-9]+)?$'),
        ])
      ),
    });
  }

  initialisedefaultShipmentContent() {
    this.defaultShipmentContent = this.fb.group({
      shipmentContentsDescription: new FormControl(
        '',
        Validators.compose([Validators.maxLength(70)])
      ),
    });
  }

  intialiseUnitPriceDecimalGroup() {
    this.defaultDecimalGroup = this.fb.group({
      unitPriceDecimalPoints: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(1),
          Validators.min(1),
          Validators.pattern('[- +()0-9]+'),
        ])
      ),
    });
  }

  intialisemotherIncotermGroup() {
    this.MotherIncotermGroup = this.fb.group({
      incoterm: new FormControl('', Validators.compose([Validators.required])),
      placeofIncoterm: new FormControl({ value: '', disabled: true }),
    });
  }

  intialiseDefaultIncotermGroup() {
    this.defaultIncotermGroup = this.fb.group({
      incoterm: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  intialiseExportDeclarationGroup() {
    this.ExportDeclarationGroup = this.fb.group({
      description: new FormControl('', Validators.compose([Validators.required])),
      signatureName: new FormControl('', Validators.compose([Validators.required])),
      signatureTitle: new FormControl('', Validators.compose([Validators.required])),
      exportReason: new FormControl('', Validators.compose([Validators.required])),
      remark: new FormControl('', Validators.compose([Validators.required])),
      signatureImage: new FormControl(''),
    });
  }

  intialiseImagePropertiesGroup() {
    this.ImagePropertiesGroup = this.fb.group({
      printerDPI: new FormControl('', Validators.compose([Validators.required])),
      encodingFormat: new FormControl('', Validators.compose([Validators.required])),
      label: new FormControl('', Validators.compose([Validators.required])),
      waybillDoc: new FormControl('', Validators.compose([Validators.required])),
      invoiceType: new FormControl('', Validators.compose([Validators.required])),
      print: new FormControl('', Validators.compose([Validators.required])),
      autoPrint: new FormControl('No', Validators.compose([Validators.required])),
    });
  }

  intialiseReportParamsGroup() {
    this.ReportParamsGroup = this.fb.group({
      reportParams: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  saveOptions() {
    if (this.defaultDecimalGroup.value.unitPriceDecimalPoints == 5) {
      const dailogData = {
        message: 'MyDHL API will be Activated to allow 5 decimal places',
      };
      const alertDialog = this.dialogRef.open(AlertComponent, {
        data: dailogData,
      });
      alertDialog.afterClosed().subscribe(res => {
        if (res == 'true') {
          this.saveConfigOptions();
        } else {
          this.dialogRef.closeAll();
        }
      });
    } else {
      this.saveConfigOptions();
    }
  }

  saveConfigOptions() {
    this.saveDefaultCurrency();
    this.saveDefaultManufacturingCtry();
    this.savedefaultIncoterm();
    this.saveDefaultWeight();
    this.saveDefaultDecimalPrice();
    this.saveDefaultShipmentContent();
    this.defaultCurrencyGroup.markAsPristine();
    this.defaultCountryGroup.markAsPristine();
    this.defaultIncotermGroup.markAsPristine();
    this.defaultWeightGroup.markAsPristine();
    this.defaultDecimalGroup.markAsPristine();
    this.defaultShipmentContent.markAsPristine();
  }

  disableSaveOption() {
    return (
      this.defaultWeightGroup.valid &&
      this.defaultIncotermGroup.valid &&
      this.defaultCurrencyGroup.valid &&
      this.defaultCountryGroup.valid &&
      this.defaultDecimalGroup.valid &&
      this.defaultShipmentContent.valid &&
      (this.defaultWeightGroup.dirty ||
        this.defaultIncotermGroup.dirty ||
        this.defaultCurrencyGroup.dirty ||
        this.defaultCountryGroup.dirty ||
        this.defaultDecimalGroup.dirty ||
        this.defaultShipmentContent.dirty)
    );
  }
  disableLabelPrint() {
    return (
      this.ImagePropertiesGroup.valid &&
      this.labelPrintConfigGroup.valid &&
      (this.labelPrintConfigGroup.dirty || this.ImagePropertiesGroup.dirty)
    );
  }

  saveDefaultWeight() {
    const configData = {
      config_id: 'default_weight',
      data: [this.defaultWeightGroup.value],
    };
    this.saveConfig(configData);
  }

  saveDefaultShipmentContent() {
    const configData = {
      config_id: 'default_shipment_content',
      data: [this.defaultShipmentContent.value],
    };
    this.saveConfig(configData);
  }

  savePaperLessTradeData() {
    const configData = {
      config_id: 'paperless-trade',
      data: [this.PaperLessTradeGroup.value],
    };
    this.saveConfig(configData);
  }

  saveDefaultDecimalPrice() {
    const configData = {
      config_id: 'unitPriceDecimalPoints',
      data: [this.defaultDecimalGroup.value],
    };
    this.saveConfig(configData);
    this.defaultDecimalGroup.markAsPristine();
  }

  saveDefaultCurrency() {
    const configData = {
      config_id: 'default_currency',
      data: [this.defaultCurrencyGroup.value],
    };
    this.saveConfig(configData);
  }

  saveDefaultManufacturingCtry() {
    const configData = {
      config_id: 'default_countryofmanufacture',
      data: [this.defaultCountryGroup.value],
    };
    this.saveConfig(configData);
  }

  saveDOMConfig() {
    const configData = {
      config_id: 'default_unitofmeasurement',
      data: [this.defaultUOMGroup.value],
    };
    this.saveConfig(configData);
    this.defaultUnitBtn = true;
  }

  saveAccountNumbers() {
    this.saveMotherAccount();
    this.saveBabyAccount();
    this.saveIndividualShipAccount();
    this.motherAccountGroup.markAsPristine();
  }

  disableSaveAccountNumbers() {
    return (
      this.babyAccountGroup.valid &&
      this.motherAccountGroup.valid &&
      this.individualShipAccountGroup.valid &&
      (this.babyAccountGroup.dirty ||
        this.motherAccountGroup.dirty ||
        this.individualShipAccountGroup.dirty)
    );
  }

  saveMotherAccount() {
    this.saveAccount(this.motherAccountGroup, 'mother_accountnumbers');
  }

  saveBabyAccount() {
    this.saveAccount(this.babyAccountGroup, 'baby_accountnumbers');
  }

  saveMotherIncoterm() {
    const config = {
      config_id: 'mother_incoterm',

      data: [
        {
          type: 'incoterm',
          value: this.MotherIncotermGroup.get('incoterm').value,
        },
      ],
    };
    this.saveConfig(config);
  }

  savedefaultIncoterm() {
    const config = {
      config_id: 'default_incoterm',

      data: [
        {
          type: 'incoterm',
          value: this.defaultIncotermGroup.get('incoterm').value,
        },
      ],
    };
    this.saveConfig(config);
  }

  saveReportParams() {
    // const config = {
    //   config_id: 'prealert_reportparams',
    //   data: this.ReportParamsGroup.value.reportParams.split(','),
    // };
  }
  saveLabelDetails() {
    this.saveImageProperties();
    this.saveLabelPrintConfig();
  }
  async saveImageProperties() {
    const additionalService = await this.configService.fetchConfig('additional_services');
    const hasPM = additionalService?.data?.filter(f => f.serviceCode == 'PM')[0] || null;
    //autoPrint: this.ImagePropertiesGroup.value.autoPrint,
    const config = {
      config_id: 'output_imageproperties',
      data: [
        {
          printerDPI: Number(this.ImagePropertiesGroup.value.printerDPI),
          encodingFormat: this.ImagePropertiesGroup.value.encodingFormat,
          imageOptions: [
            {
              typeCode: 'label',
              templateName: this.ImagePropertiesGroup.value.label,
            },
            {
              typeCode: 'waybillDoc',
              templateName: this.ImagePropertiesGroup.value.waybillDoc,
              isRequested: true,
              hideAccountNumber: true,
              numberOfCopies: 1,
            },
            {
              invoiceType: 'commercial',
              isRequested: hasPM ? false : true,
              languageCode: 'eng',
              templateName: 'COMMERCIAL_INVOICE_P_10',
              typeCode: 'invoice',
            },
            {
              typeCode: 'waybillDocPrint',
              print: this.printValue(),
            },
          ],
          splitTransportAndWaybillDocLabels: false,
          allDocumentsInOneImage: false,
          splitDocumentsByPages: false,
        },
      ],
    };
    this.saveConfig(config);
    this.ImagePropertiesGroup.markAsPristine();
  }

  printValue() {
    return String(this.ImagePropertiesGroup.value.print) === 'true';
  }

  saveExportDeclarations() {
    const config = {
      config_id: 'mother_exportdeclarationdetails',
      data: [
        {
          content: {
            exportDeclaration: {
              invoice: {
                invoiceExportReason: this.ExportDeclarationGroup.value.invoiceExportReason,
                placeOfIncoterm: this.MotherIncotermGroup.value.placeofIncoterm,
                signatureName: this.ExportDeclarationGroup.value.signatureName.trim(),
                signatureTitle: this.ExportDeclarationGroup.value.signatureTitle.trim(),
                signatureImage: this.signatureImage,
              },
              remarks: [{ value: this.ExportDeclarationGroup.value.remark.trim() }],
              exportReason: this.ExportDeclarationGroup.value.exportReason,
            },
            description: this.ExportDeclarationGroup.value.description.trim(),
          },
        },
      ],
    };
    this.saveMotherIncoterm();
    this.saveDOMConfig();
    this.saveConfig(config);
    this.ExportDeclarationGroup.markAsPristine();
    this.defaultUOMGroup.markAsPristine();
    this.MotherIncotermGroup.markAsPristine();
  }

  saveAccount(configForm, id) {
    const configData = {
      config_id: id,
      data: [
        {
          name: 'shipperAccountNumber',
          typeCode: 'shipper',
          number: configForm.value.shipperAccountNumber,
        },
        {
          name: 'payerAccountNumber',
          typeCode: 'payer',
          number: configForm.value.payerAccountNumber,
        },
      ],
    };

    if (configForm.value.dutyAccountNumber && configForm.value.dutyAccountNumber.length > 0) {
      const dutyObj = {
        name: 'dutyAccountNumber',
        typeCode: 'duties-taxes',
        number: configForm.value.dutyAccountNumber,
      };
      configData.data.push(dutyObj);
    }

    this.saveConfig(configData);
  }

  saveExportInvoice() {
    const configData = {
      config_id: 'default_invoice_export',
      data: [this.exportInvoiceGroup.value.exportInvoice],
    };
    this.saveConfig(configData);
  }

  saveConfig(config) {
    this.configService.saveConfig(config).subscribe(res => {
      sessionStorage.setItem('isCustomInvoice', this.exportInvoiceGroup.value.exportInvoice);
      this.snackBarService.createSnackBar(
        basicSnackBarConfig.addressComponentSave?.message,
        basicSnackBarConfig.addressComponentSave?.horizontalPosition,
        basicSnackBarConfig.addressComponentSave?.verticalPosition,
        basicSnackBarConfig.addressComponentSave?.duration
      );

      if (this.customerOnBoardingVerification === 'VERIFY') {
        this.configService.validateConfiguration().subscribe((response: any) => {
          if (response.length > 0) {
            this.validateConfig(response);
          } else {
            this.dialogRef.closeAll();
          }
        });
      }
      if (res) {
        this.configService.putConfig(config.config_id, res['data']);
      }
    });
  }

  setWayBill(type) {
    this.ImagePropertiesGroup.patchValue({
      waybillDoc: this.looseBbx
        ? this.onChangeLabelTypeMappingLbbx[type]
        : this.onChangeLabelTypeMapping[type],
    });
  }

  isPostalCodeCityValid() {
    return this.isPostalCodeValid && this.isCityValid;
  }

  intialiseCustomerCredentialFormGroup() {
    this.customerCredentialGroup = this.fb.group({
      mydhlApiKey: new FormControl('', Validators.compose([])),
      mydhlApiPassword: new FormControl('', Validators.compose([])),
      postalLocationApiKey: new FormControl('', Validators.compose([])),
    });
  }

  saveCustomerCredential() {
    const configData = {
      config_id: 'customer_credential',
      data: [this.customerCredentialGroup.value],
    };
    this.saveConfig(configData);
    this.customerCredentialGroup.markAsPristine();
  }

  filterConfigurationList() {
    return this.configurationList.filter(
      item =>
        !(item.title == 'Customer Credential' && this.bbxUserRole == 'OPS_USER') &&
        !(item.title == 'Workflow Configuration' && this.bbxUserRole == 'OPS_USER')
    );
  }

  filterSaveAddressAccess() {
    if (!this.hasAccessToSaveAddress()) {
      const e = e => e.config_id !== 'save_reciever_address';
      this.configurationList = this.configurationList.filter(e);
      this.configurationPageList = this.configurationPageList.filter(e);
    }
  }

  hasAccessToSaveAddress() {
    return this.bbxUserRole == 'GLOBAL_ADMIN' || this.bbxUserRole == 'COUNTRY_IT_ADMIN';
  }

  intialisePickupsConfigGroup() {
    this.pickupsConfigGroup = this.fb.group({
      readyTime: new FormControl('', Validators.compose([Validators.required])),
      closingTime: new FormControl('', Validators.compose([Validators.required])),
      instructions: new FormControl('', Validators.compose([Validators.required])),
      location: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  intialiseBbxConfigGroup() {
    this.bbxConfigGroup = this.fb.group({
      bbxType: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  intialiseLabelPrintConfigGroup() {
    this.labelPrintConfigGroup = this.fb.group({
      printPieceLevel: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  initialiseBabyDefaultOptions() {
    this.babyDefaultOptionsGroup = this.fb.group({
      productCode: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('^[AB]+$'),
        ])
      ),
      motherProductCode: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('^[PH]+$'),
        ])
      ),
      localProductCode: new FormControl(
        '',
        Validators.compose([
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('B'),
        ])
      ),
      isCustomsDeclarable: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(1),
          Validators.minLength(1),
          Validators.pattern('[YN]'),
        ])
      ),
      showDGContentID: new FormControl(),
      DGContentID: [],
      customDescription: this.fb.array([]),
      productName: [],
    });
  }

  getDGContentIDs() {
    const workflow = sessionStorage.getItem('loose-bbx');
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForShipmentDetailsUpdate))
      .then(response => {
        this.DGContentIDValues = response[0].data;
        if (workflow === 'No') {
          this.DGContentIDValues = this.DGContentIDValues.filter(function (arrayObj) {
            return arrayObj.name !== 'UN2807 Magnetized Material';
          });
        }
      });
  }

  saveBabyDefaultOptions() {
    if (!this.validateCustomDescription()) return;
    const configData = {
      config_id: 'baby_default_options',
      data: [
        {
          ...this.babyDefaultOptionsGroup.value,
          showDGContentID:
            this.babyDefaultOptionsGroup.value.DGContentID &&
            this.babyDefaultOptionsGroup.value.DGContentID.length
              ? true
              : false,
          customDescription: this.babyDefaultOptionsGroup.value.customDescription
            .map(item => item?.description?.trim())
            .filter(item => item),
        },
      ],
    };
    this.saveProductNameConfig();
    delete configData?.data[0]?.productName;
    this.saveConfig(configData);
  }

  addDgContent(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.babyDefaultOptionsGroup.controls.customDescription.clearValidators();
    this.babyDefaultOptionsGroup.patchValue({ DGContentID: [] });
    this.isSpecialProvisionSelected = false;
    this.babyDefaultOptionsGroup.patchValue({
      showDGContentID: value === 'true',
      DGContentID: [],
    });
  }

  saveBbxConfig() {
    const configData = {
      config_id: 'loose_bbx',
      data: [this.bbxConfigGroup.value.bbxType],
    };
    this.saveConfig(configData);
    sessionStorage.setItem('loose-bbx', this.bbxConfigGroup.value.bbxType);
    this.setImageProperties(configData.data[0]);
  }

  customerCredentialDisplay() {
    this.credSubscription$.add(
      this.behaviourService.currentMessage.subscribe(response => {
        if (response == 'true') {
          this.selectedConfiguration = this.configOnBoarding.CUSTOMER_CREDENTIAL;
        } else this.selectedConfiguration = 0;
      })
    );
  }

  checkFields() {
    this.customerCredentialGroup.controls.mydhlApiKey.clearValidators();
    this.customerCredentialGroup.controls.mydhlApiPassword.clearValidators();
    this.customerCredentialGroup.controls.postalLocationApiKey.clearValidators();
    const apiKey = this.customerCredentialGroup.controls.mydhlApiKey.value.trim();
    const apiPswd = this.customerCredentialGroup.controls.mydhlApiPassword.value.trim();
    const postalLoc = this.customerCredentialGroup.controls.postalLocationApiKey.value.trim();
    this.dhlKeyReqd = false;
    this.dhlPswdReqd = false;
    if ((apiKey != null && apiKey != '') || (apiPswd != null && apiPswd != '')) {
      this.customerCredentialGroup.controls.mydhlApiKey.setValidators([Validators.required]);
      this.customerCredentialGroup.controls.mydhlApiPassword.setValidators([Validators.required]);
      this.customerCredentialGroup.controls.postalLocationApiKey.setValidators([]);
      this.dhlKeyReqd = true;
      this.dhlPswdReqd = true;
    } else if (apiKey == '' && apiPswd == '' && postalLoc !== '') {
      this.customerCredentialGroup.controls.mydhlApiKey.setValidators([]);
      this.customerCredentialGroup.controls.mydhlApiPassword.setValidators([]);
      this.customerCredentialGroup.controls.postalLocationApiKey.setValidators([
        Validators.required,
      ]);
    } else if (apiKey == '' && apiPswd == '' && postalLoc == '') {
      this.customerCredentialGroup.controls.mydhlApiKey.setValidators([Validators.required]);
      this.customerCredentialGroup.controls.mydhlApiPassword.setValidators([Validators.required]);
      this.customerCredentialGroup.controls.postalLocationApiKey.setValidators([
        Validators.required,
      ]);
    }

    this.customerCredentialGroup.controls.mydhlApiKey.updateValueAndValidity();
    this.customerCredentialGroup.controls.mydhlApiPassword.updateValueAndValidity();
    this.customerCredentialGroup.controls.postalLocationApiKey.updateValueAndValidity();
  }
  saveLabelPrintConfig() {
    const configData = {
      config_id: 'label_print_config',
      data: [this.labelPrintConfigGroup.value],
    };
    this.saveConfig(configData);
    this.labelPrintConfigGroup.markAsPristine();
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  setImageProperties(item) {
    this.looseBbx = item == 'Yes' ? true : false;
    if (this.looseBbx == true) {
      this.labelTypes = this.imageDocTemplates.labelTypesLbbx;
      if (
        this.ImagePropertiesGroup.value.label == this.imageDocTemplates.labelTypes['PDF A4'] ||
        this.ImagePropertiesGroup.value.label == this.imageDocTemplates.labelTypes['PDF 8x4']
      ) {
        this.ImagePropertiesGroup?.get('label')?.setValue(
          this.imageDocTemplates.labelTypesLbbx['PDF 8x4']
        );
      } else if (
        this.ImagePropertiesGroup.value.label == this.imageDocTemplates.labelTypes['PDF 6x4']
      ) {
        this.ImagePropertiesGroup?.get('label')?.setValue(
          this.imageDocTemplates.labelTypesLbbx['PDF 6x4']
        );
      }
      // else{
      //   this.ImagePropertiesGroup?.get('label')?.setValue(
      //     this.imageDocTemplates.labelTypesLbbx['PDF 8x4']
      //   );
      // }
    } else {
      this.labelTypes = this.imageDocTemplates.labelTypes;
      if (
        this.ImagePropertiesGroup.value.label == this.imageDocTemplates.labelTypesLbbx['PDF 8x4']
      ) {
        this.ImagePropertiesGroup?.get('label')?.setValue(
          this.imageDocTemplates.labelTypes['PDF 8x4']
        );
      } else if (
        this.ImagePropertiesGroup.value.label == this.imageDocTemplates.labelTypesLbbx['PDF 6x4']
      ) {
        this.ImagePropertiesGroup?.get('label')?.setValue(
          this.imageDocTemplates.labelTypes['PDF 6x4']
        );
      }
      // else{
      //   this.ImagePropertiesGroup?.get('label')?.setValue(
      //     this.imageDocTemplates.labelTypes['PDF 8x4']
      //   );
      // }
    }
    this.setWayBill(this.ImagePropertiesGroup.value.label);
    this.saveImageProperties();
  }

  onSignatureImageUpload(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file?.size >= 256000) {
      this.resetSignatureImage();
      this.errorDialogService.openDialog(validForSISizeMessage, false);
      (event.target as HTMLInputElement).value = null;
      return;
    }
    this.signatureImageData = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      this.signatureImage = reader.result.toString().split(',')[1];
    };
    this.ExportDeclarationGroup.markAsDirty();
  }

  resetSignatureImage() {
    this.ExportDeclarationGroup.get('signatureImage').reset();
    this.signatureImage = '';
    this.ExportDeclarationGroup.markAsDirty();
  }

  openView() {
    const dialogRef = this.dialogRef.open(LabelViewComponent, {
      data: {
        label: this.signatureImage,
        labelName: this.translate.instant('configuration.customerOnboarding.signatureImage'),
        format: 'png',
      },
      maxHeight: '90vh',
      maxWidth: '50vw',
    });
    dialogRef.afterClosed().subscribe(() => ``);
  }

  setPlaceofIncoterm(incoterm: string) {
    this.MotherIncotermGroup.get('placeofIncoterm').setValue(getPlaceofIncotermValue(incoterm));
  }

  getDGContentValue(valueData: any) {
    this.isSpecialProvisionSelected = valueData.value?.some(val =>
      this.specialProvision.includes(val)
    );
    if (this.isSpecialProvisionSelected) {
      !valueData?.description?.length
        ? this.addCustumDescription([''])
        : this.addCustumDescription(valueData?.description);
    } else {
      (this.babyDefaultOptionsGroup.get('customDescription') as FormArray).clear();
    }
  }

  getDGContentValueChange(valueData: any) {
    if (
      valueData.value?.some(val => this.specialProvision.includes(val)) &&
      this.specialProvision.includes(this.currentSelectedContent)
    ) {
      this.isSpecialProvisionSelected = true;
      (this.babyDefaultOptionsGroup.get('customDescription') as FormArray).clear();
      this.addCustumDescription(['']);
    }
    if (!valueData.value?.some(val => this.specialProvision.includes(val))) {
      this.isSpecialProvisionSelected = false;
      (this.babyDefaultOptionsGroup.get('customDescription') as FormArray).clear();
    }
  }

  get getCustumDescriptionArray() {
    return this.babyDefaultOptionsGroup.get('customDescription') as FormArray;
  }

  addCustumDescription(descriptionArray = ['']) {
    descriptionArray.forEach(description => {
      const control = this.babyDefaultOptionsGroup.get('customDescription') as FormArray;
      control.insert(
        (this.babyDefaultOptionsGroup.get('customDescription') as FormArray).controls.length + 1,
        this.fb.group({ description: new FormControl(description) })
      );
    });
  }

  deleteDescription(index: number) {
    if (this.getCustumDescriptionArray.value.length === 1) {
      return this.errorDialogService.openDialog('alert.containOneDescription', false);
    }
    const descriptionGrp = this.babyDefaultOptionsGroup.get('customDescription') as FormArray;
    descriptionGrp.removeAt(index);
    this.babyDefaultOptionsGroup.markAsDirty();
  }

  trackByFn(index: number) {
    return index;
  }

  validateCustomDescription() {
    if (this.getCustumDescriptionArray.value.length === 1) {
      const firstFiled = this.getCustumDescriptionArray.at(0)?.value?.description;
      if (!firstFiled) {
        this.babyDefaultOptionsGroup.controls['customDescription'].setErrors({ incorrect: true });
        return false;
      }
      this.babyDefaultOptionsGroup.controls['customDescription'].setErrors(null);
    }
    return true;
  }
  savePickupConfig() {
    const configData = {
      config_id: 'pickup_default_settings',
      data: [this.pickupsConfigGroup.value],
    };
    this.saveConfig(configData);
    this.pickupsConfigGroup.markAsPristine();
  }

  disablePickupSave() {
    return this.closeError || this.readyError ? false : true;
  }
  disableExportDeclOptions() {
    return (
      this.ExportDeclarationGroup.valid &&
      this.defaultUOMGroup.valid &&
      this.MotherIncotermGroup.valid &&
      (this.ExportDeclarationGroup.dirty ||
        this.defaultUOMGroup.dirty ||
        this.MotherIncotermGroup.dirty)
    );
  }
  saveReportConfig() {
    this.reportConfigGroup.get('email').patchValue('');
    this.emailArray = this.reportConfigGroup.get('EmailList').value;
    const configData = {
      config_id: 'report_configuration',
      data: [this.reportConfigGroup.value],
    };
    this.saveConfig(configData);
    this.reportConfigGroup.markAsPristine();
  }
  disableSaveReportConfig() {
    return this.reportConfigGroup.valid && this.reportConfigGroup.dirty;
  }
  addEmailIdToList() {
    if (this.reportConfigGroup.get('email').value) {
      if (this.emailArray && this.emailArray.length > 0) {
        if (
          this.emailArray.indexOf(
            this.reportConfigGroup.get('email').value.toString().toLowerCase()
          ) == -1
        ) {
          this.emailArray.push(this.reportConfigGroup.get('email').value.toString());
          this.reportConfigGroup.get('email').setValue('');
        } else {
          this.errorDialogService.openDialog('alert.emailExist', false);
        }
      } else {
        this.emailArray = [];
        this.emailArray.push(this.reportConfigGroup.get('email').value.toString());
        this.reportConfigGroup.get('email').setValue('');
      }
      this.reportConfigGroup.get('EmailList').patchValue(this.emailArray);
    }
  }

  intialiseIndividualShipAccountGroup() {
    this.individualShipAccountGroup = this.fb.group({
      payerAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.minLength(9), Validators.maxLength(9)])
      ),
      dutyAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.minLength(9), Validators.maxLength(9)])
      ),
      shipperAccountNumber: new FormControl(
        '',
        Validators.compose([Validators.minLength(9), Validators.maxLength(9)])
      ),
    });
  }

  intialiseIndividualShipmentExportDeclarationGroup() {
    this.individualShipmentExportDeclarationGroup = this.fb.group({
      description: new FormControl(''),
      signatureName: new FormControl('', Validators.compose([Validators.required])),
      signatureTitle: new FormControl('', Validators.compose([Validators.required])),
      exportReason: new FormControl('', Validators.compose([Validators.required])),
      remark: new FormControl(''),
      signatureImage: new FormControl(''),
      invoiceUnitOfMeasurement: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(60)])
      ),

      lineItemQuantityUnitofMeasurement: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
      incoterm: new FormControl('', Validators.compose([Validators.required])),
      placeOfIncoterm: new FormControl(''),
    });
  }

  saveIndividualShipAccount() {
    this.saveAccount(this.individualShipAccountGroup, 'individualShip_accountnumbers');
  }

  saveIndividualShipmentExportDeclarations() {
    const config = {
      config_id: 'individualShipment_exportdeclarationdetails',
      data: [
        {
          content: {
            exportDeclaration: {
              invoice: {
                invoiceExportReason:
                  this.individualShipmentExportDeclarationGroup.value.invoiceExportReason,
                placeOfIncoterm:
                  this.individualShipmentExportDeclarationGroup.value.placeOfIncoterm,
                signatureName:
                  this.individualShipmentExportDeclarationGroup.value.signatureName.trim(),
                signatureTitle:
                  this.individualShipmentExportDeclarationGroup.value.signatureTitle.trim(),
                signatureImage: this.signatureImageIndShip,
                invoiceUnitOfMeasurement:
                  this.individualShipmentExportDeclarationGroup.value.invoiceUnitOfMeasurement,
                lineItemQuantityUnitofMeasurement:
                  this.individualShipmentExportDeclarationGroup.value
                    .lineItemQuantityUnitofMeasurement,
                incoterm: this.individualShipmentExportDeclarationGroup.value.incoterm,
              },
              remarks: [
                { value: this.individualShipmentExportDeclarationGroup.value.remark.trim() },
              ],
              exportReason: this.individualShipmentExportDeclarationGroup.value.exportReason,
            },
            description: this.individualShipmentExportDeclarationGroup.value.description.trim(),
          },
        },
      ],
    };
    this.saveConfig(config);
    this.individualShipmentExportDeclarationGroup.markAsPristine();
  }

  getProductNameData() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForProductName))
      .then(response => {
        this.allProductNameValues = response[0]?.data;
        this.individualProductCodes = response[0]?.data?.filter(
          item => item.activeForSetConfig === true
        );
        const selectedCodes = response[0]?.data
          ?.filter(item => item.setConfig)
          .map(item => item.productCode);
        this.babyDefaultOptionsGroup.patchValue({
          productName: selectedCodes,
        });
      });
  }

  saveProductNameConfig() {
    if (
      this.selectedProductNames &&
      this.selectedProductNames.length > 0 &&
      this.selectedProductNames.length === this.allProductNameValues.length
    ) {
      const configData = {
        config_id: 'productcode_list',
        data: this.selectedProductNames,
      };
      this.saveConfig(configData);
    }
  }

  onSignatureImageUploadForIndShip(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file?.size >= 256000) {
      this.resetSignatureImageForInvShip();
      this.errorDialogService.openDialog(validForSISizeMessage, false);
      (event.target as HTMLInputElement).value = null;
      return;
    }
    this.signatureImageDataIndShip = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      this.signatureImageIndShip = reader.result.toString().split(',')[1];
    };
    this.individualShipmentExportDeclarationGroup.markAsDirty();
  }

  resetSignatureImageForInvShip() {
    this.individualShipmentExportDeclarationGroup.get('signatureImage').reset();
    this.signatureImageIndShip = '';
    this.individualShipmentExportDeclarationGroup.markAsDirty();
  }

  openViewIndShip() {
    const dialogRef = this.dialogRef.open(LabelViewComponent, {
      data: {
        label: this.signatureImageIndShip,
        labelName: this.translate.instant('configuration.customerOnboarding.signatureImage'),
        format: 'png',
      },
      maxHeight: '90vh',
      maxWidth: '50vw',
    });
    dialogRef.afterClosed().subscribe(() => ``);
  }

  getProductNameValueChange(valueData: any) {
    valueData?.value.push('A');
    valueData?.value.push('B');
    this.selectedProductNames = this.allProductNameValues.map((item: any) => {
      const shouldSet = valueData?.value?.includes(item.productCode);
      return {
        ...item,
        setConfig: item.productCode === 'A' || item.productCode === 'B' ? false : !!shouldSet,
        activeForSetConfig: item.productCode === 'A' || item.productCode === 'B' ? false : true,
      };
    });
  }

  disableIndividualShipmentExportDeclOptions() {
    return (
      this.individualShipmentExportDeclarationGroup.valid &&
      this.defaultUOMGroup.valid &&
      this.MotherIncotermGroup.valid &&
      (this.individualShipmentExportDeclarationGroup.dirty ||
        this.defaultUOMGroup.dirty ||
        this.MotherIncotermGroup.dirty)
    );
  }
}
